(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
